import { message } from "antd";
import { makeAutoObservable } from "mobx"; // 导入封装好的API函数
import { UserInfo } from "./User";
import { MixApi } from "../apis/Mix";
import { UserApi } from "../apis/User";
import "../apis/mock/Mix";
import CryptoJS from "crypto-js";

    
class GlobalStore {
    currentUser:UserInfo | null = null;
    selectedMenuKey: string = 'home'; 
    isLoggedIn: boolean = false; // 用户登录状态
    isLoginModalVisible: boolean = false; // 控制登录框的可见性
    initialized :boolean  = false;  
    configMap:Map<string,any> = new Map();  

    constructor() {
        makeAutoObservable(this);
    } 

    // 初始化函数
    async init() {
        if(this.initialized){
            return;
        }
        this.configMap = await MixApi.getConfigs();  
        const token = localStorage.getItem("token");
        console.log("---------------token", token);
        if (token) {
            const data = await UserApi.getUserByToken();
            if (data && data.token) {
                this.currentUser = data;
                this.isLoggedIn = true;
            } else {
                this.clearLocalSession();
                message.warning("登录已过期，请重新登录");
            }
        }
        this.initialized = true;
    }

    // 登录
    async login(phone: string, password: string) {
        const passwordMd5 = CryptoJS.MD5(password).toString();
        const data = await UserApi.loginApi(phone, passwordMd5);
        if (data) {
            this.currentUser = data;
            this.isLoggedIn = true;
            localStorage.setItem("token", data.token as string);
            this.isLoginModalVisible = false;
        } else {
            message.error("登录失败，请检查手机号或密码");
        }
    }

    async logout() {
        try {
            await UserApi.logoutApi();
        } finally {
            this.clearLocalSession();
        }
    }

    /** 未登录/会话失效：清本地态，App 会因 isLoggedIn=false 回到登录页 */
    forceLogoutToLogin() {
        if (!this.isLoggedIn && !localStorage.getItem("token")) {
            return;
        }
        this.clearLocalSession();
        message.warning("登录已失效，请重新登录");
    }

    clearLocalSession() {
        localStorage.removeItem("token");
        this.currentUser = null;
        this.isLoggedIn = false;
        this.isLoginModalVisible = false;
    }

    closeLoginModal() {
        this.isLoginModalVisible = false;
    }
}

export const globalStore = new GlobalStore();